module.exports = __webpack_public_path__ + "static/winter-377c9056aa8c53a1c1b23f8c522be665.jpg";